import {
  Scene,
  Vector2,
  Vector3,
  Camera,
  Raycaster,
  Intersection,
  Mesh
} from "three";

export class XRControls {
  private scaling = false;
  private rotating = false;
  private translating = false;
  private previousTouchList:TouchList;
  private canvasContainer:HTMLElement;
  private raycaster = new Raycaster();
  private mouse = new Vector2();
  // private translationTimeout:any = -1;

  public constructor(public scene:Scene, private camera:Camera) {
    this.canvasContainer = document.getElementById("scene-canvas");
  }

  public install():void {
    this.canvasContainer.addEventListener('touchstart', this.onTouchStart);
    this.canvasContainer.addEventListener('touchmove', this.onTouchMove);
  }

  public remove():void {
    this.canvasContainer.removeEventListener('touchstart', this.onTouchStart);
    this.canvasContainer.removeEventListener('touchmove', this.onTouchMove);
  }

  private onTouchStart = (e:TouchEvent) => {
    this.previousTouchList = e.touches;

    this.scaling = false;
    this.rotating = false;
    this.translating = false;

    if (e.touches.length == 2) {
      this.scaling = true;
    } else if (e.touches.length == 1) {
      // Touch on car is translation, touch outside is rotation.
      if (this.intersectTouchWithScene(e) !== undefined) {
        this.translating = true;
      } else {
        this.rotating = true;
      }
    }
  };

  private onTouchMove = (e:TouchEvent) => {
    if (this.scaling) {
      if (e.touches.length != 2) {
        this.scaling = false;
        return;
      }

      const oldDistX = this.previousTouchList[0].clientX - this.previousTouchList[1].clientX;
      const oldDistY = this.previousTouchList[0].clientY - this.previousTouchList[1].clientY;
      const newDistX = e.touches[0].clientX - e.touches[1].clientX;
      const newDistY = e.touches[0].clientY - e.touches[1].clientY;

      const change = (newDistX * newDistX + newDistY * newDistY) - (oldDistX * oldDistX + oldDistY * oldDistY);

      let scale = this.scene.scale.x;

      if (change >  50) {
        scale += 0.01;//0.01;
      }

      if (change < -50) {
        scale -= 0.01 * Math.sqrt(scale);//0.01 * this.scale;
        scale = Math.max(0, scale);
      }

      this.scene.scale.set(scale, scale, scale);
    }

    if (this.rotating) {
      if (e.touches.length != 1) {
        this.rotating = false;
        return;
      }

      const distX = e.touches[0].clientX - this.previousTouchList[0].clientX;

      if (distX >  0.01) {
        this.scene.rotation.y += 0.05;
        // this.clearTranslationTimeout();
      }

      if (distX < -0.01) {
        this.scene.rotation.y -= 0.05;
        // this.clearTranslationTimeout();
      }
    }

    if (this.translating) {
      if (e.touches.length != 1) {
        this.translating = false;
        return;
      }

      let distX = e.touches[0].clientX - this.previousTouchList[0].clientX;
      let distY = e.touches[0].clientY - this.previousTouchList[0].clientY;

      // if (window.matchMedia("(orientation: landscape)").matches) {
      //   const tmp = distX;
      //   distX = distY;
      //   distY = tmp;
      // }

      const matrix = this.camera.matrixWorld.elements;
      const right = new Vector3(matrix[0], 0, matrix[2]).normalize();
      const forward = new Vector3(matrix[8], 0, matrix[10]).normalize();

      const maxImpulse = 160 * window.devicePixelRatio;
      this.scene.position.addScaledVector(right, Math.min(1, distX / maxImpulse));
      this.scene.position.addScaledVector(forward, Math.min(1, distY / maxImpulse));

    }

    this.previousTouchList = e.touches;
  };

  private intersectTouchWithScene(event:TouchEvent):Intersection {
    // TODO: this assumes that the canvas always fills the app container.
    // This was preferred over using the engine canvas as it works in WebXR.
    const contentDiv = document.getElementById("app-include-content");
    const clientRect = contentDiv.getBoundingClientRect();
    this.mouse.x =   ((event.touches[0].clientX - clientRect.left) / contentDiv.clientWidth ) * 2 - 1;
    this.mouse.y = -(((event.touches[0].clientY - clientRect.top ) / contentDiv.clientHeight) * 2 - 1);

    this.raycaster.setFromCamera(this.mouse, this.camera);

    const intersections = this.raycaster.intersectObjects(this.scene.children, true).filter(
      intersection => {
        const object = intersection.object;

        if (!object.visible) {
          return false;
        }

        if ((object instanceof Mesh) && !Array.isArray(object.material) && object.material.transparent) {
          return false;
        }

        return true;
      });

    return intersections[0];
  }

  // private startTranslationTimeout():void {
  //   this.translationTimeout = setTimeout(() => {
  //     this.rotating = false;
  //     this.translating = true;
  //   }, 1000);
  // }

  // private clearTranslationTimeout():void {
  //   if (this.translationTimeout != -1) {
  //     clearTimeout(this.translationTimeout);
  //     this.translationTimeout = -1;
  //   }
  // }
}